import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCut';
/** Renders an SVG icon. */
const SvgCut = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M15.021 17.566a1 1 0 0 1 1.414-.044l8.25 7.75a1 1 0 1 1-1.37 1.457l-8.25-7.75a1 1 0 0 1-.043-1.413ZM9 21.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M22 15a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2zm7 0a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2zM9 10.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m2 0c0 .596-.15 1.156-.412 1.647l2.67 2.487 10.06-9.365a1 1 0 0 1 1.364 1.463l-14.094 13.12A3.5 3.5 0 1 1 9.18 18.43L11.792 16l-2.611-2.43A3.5 3.5 0 1 1 11 10.5"
      />
    </svg>
  );
};
SvgCut.displayName = displayName;
export default SvgCut;
